







import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {AxiosResponse} from 'axios';
import {JobRunning, ServiceTransactionInitState} from '@/store/service-transaction/service-transaction.types';
import {TimeUsed} from '@/services/time.service';

@Component({
  components: {}
})
export default class PaymentJobRunningComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @Action('_checkJobIsRunning', {namespace: 'serviceTransaction'}) checkJobIsRunning!: () => Promise<AxiosResponse>;

  public jobRunning = {} as JobRunning;
  public view = {
    timeUsed: '',
    timeReceive: ''
  };

  mounted() {
    this.checkJobIsRunning().then((res: AxiosResponse) => {
      if (res.status === 200) {
        if (res.data.appCode === 20004) {
          // this.$router.push('/payment-information');
          this.jobRunning = this.serviceTransactionInitState.jobRunning;
          this.view.timeUsed = `${this.jobRunning.subService.name} เวลาที่ทำไปแล้ว ${TimeUsed({
            timeEnd: new Date(),
            timeStart: this.jobRunning.serviceStartDate
          })}`;
          this.view.timeReceive = `${this.jobRunning.timeTransactions[0].remain} นาที`;
        }
      }
    })
  }

  jobRunningClick() {
    this.$router.push('/payment-information').then();
  }
}
